// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/ArrowDownBlack.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Mono&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* For Webkit-based browsers (Chrome, Safari and Opera) */
.left-form::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.left-form {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.auth-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right;
  -webkit-appearance: none;
  background-position-x: 95%;
}

.otp div {
  justify-content: space-between;
}

.inputGroup {
  background-color: #fff;
  display: block;
  position: relative;
}

.inputGroup input {
  width: 18px;
  height: 18px;
  order: 1;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  visibility: hidden;
}

.inputGroup input:checked ~ label {
  color: #000;
}

.inputGroup label {
  padding: 0px 30px 12px;
  width: 100%;
  display: block;
  text-align: left;
  color: #000;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: color 200ms ease-in;
  overflow: hidden;
}

.inputGroup input:checked ~ label:before {
  transform: translate(-50%, -50%) scale3d(56, 56, 1);
  opacity: 1;
}


.inputGroup input:checked ~ label:after {
  background-color: #000000;
  border-color: #000000;
}

.inputGroup label:after {
  width: 18px;
  height: 18px;
  content: "";
  border: 2px solid #000000;
  background-color: #fff;
  z-index: 2;
  position: absolute;
  border-radius: 50%;
  left: 0;
  top: 5px;
  cursor: pointer;
  transition: all 200ms ease-in;
}


.light-margin {
  margin-bottom: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/create-account/style.css"],"names":[],"mappings":"AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,mEAAyE;EACzE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,UAAU;AACZ;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,eAAe;EACf,6BAA6B;AAC/B;;;AAGA;EACE,8BAA8B;AAChC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Mono&display=swap');\n\n/* For Webkit-based browsers (Chrome, Safari and Opera) */\n.left-form::-webkit-scrollbar {\n  display: none;\n}\n\n/* For IE, Edge and Firefox */\n.left-form {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.auth-select {\n  background: url('../../assets/images/ArrowDownBlack.svg') no-repeat right;\n  -webkit-appearance: none;\n  background-position-x: 95%;\n}\n\n.otp div {\n  justify-content: space-between;\n}\n\n.inputGroup {\n  background-color: #fff;\n  display: block;\n  position: relative;\n}\n\n.inputGroup input {\n  width: 18px;\n  height: 18px;\n  order: 1;\n  z-index: 2;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  visibility: hidden;\n}\n\n.inputGroup input:checked ~ label {\n  color: #000;\n}\n\n.inputGroup label {\n  padding: 0px 30px 12px;\n  width: 100%;\n  display: block;\n  text-align: left;\n  color: #000;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  transition: color 200ms ease-in;\n  overflow: hidden;\n}\n\n.inputGroup input:checked ~ label:before {\n  transform: translate(-50%, -50%) scale3d(56, 56, 1);\n  opacity: 1;\n}\n\n\n.inputGroup input:checked ~ label:after {\n  background-color: #000000;\n  border-color: #000000;\n}\n\n.inputGroup label:after {\n  width: 18px;\n  height: 18px;\n  content: \"\";\n  border: 2px solid #000000;\n  background-color: #fff;\n  z-index: 2;\n  position: absolute;\n  border-radius: 50%;\n  left: 0;\n  top: 5px;\n  cursor: pointer;\n  transition: all 200ms ease-in;\n}\n\n\n.light-margin {\n  margin-bottom: 3rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
